import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

const REDIRECT_URL_PARAM = 'redirectUrl';

@Injectable()
export class RedirectService {
  private destination: string|string[];
  constructor(
      private readonly router: Router,
      private readonly route: ActivatedRoute,
  ) {
    console.log("🧠", this);
  }

  public rememberFromURL() {
    const url = this.route.snapshot.queryParamMap.get(REDIRECT_URL_PARAM);
    if (url) {
      this.remember(url);
    }
  }

  public remember(destination: string) {
    this.destination = destination;
  }

  public async restore(fallback?: string|string[]): Promise<void> {
    this.destination = this.destination || fallback;
    if (Array.isArray(this.destination)) {
      await this.router.navigate(this.destination);
    } else if (this.destination.includes('://')) {
      window.location.href = this.destination;
    } else {
      await this.router.navigateByUrl(this.destination);
    }
    delete this.destination;
  }



}
